import useFetchAllPurchases from "../../hooks/useFetchAllPurchases";
import useFetchDomains from "../../hooks/useFetchDomains";
import "./PurchaseHistoryScreen.css";

export default function PurchaseHistoryScreen() {
    const { history, loading } = useFetchAllPurchases();
    const { domains } = useFetchDomains();

    if (loading) return <p className="loading-text">Loading...</p>;

    // 🔥 Create { domainId: domainName }
    const domainMap = {};
    domains.forEach((d) => {
        domainMap[d.id] = d.name;
    });

    return (
        <div className="history-page">
            <h1 className="history-title">Purchase History</h1>

            {history.length === 0 ? (
                <p className="no-history">No purchases found.</p>
            ) : (
                <div className="history-list">
                    {history.map((item) => {
                        const isExpired = item.expired;
                        const domainName = domainMap[item.domainId] || item.domainId;

                        return (
                            <div key={`${item.domainId}-${item.packId}`} className="history-card">
                                <div className="history-header">
                                    <h3>{item.packName}</h3>
                                    <span className={`status-badge ${isExpired ? "expired" : "active"}`}>
                                        {isExpired ? "Expired" : "Active"}
                                    </span>
                                </div>

                                {/* 🔥 Now showing DOMAIN NAME instead of ID */}
                                <p className="domain">Domain: {domainName}</p>

                                <div className="history-details">
                                    <div>
                                        <label>Purchased On</label>
                                        <p>{new Date(item.createdAt).toLocaleDateString()}</p>
                                    </div>

                                    <div>
                                        <label>Price Paid</label>
                                        <p>₹{item.finalPrice}</p>
                                    </div>

                                    <div>
                                        <label>Validity</label>
                                        <p>{item.validity ? `${item.validity} days` : "Lifetime"}</p>
                                    </div>

                                    <div>
                                        <label>Expiry Date</label>
                                        <p>
                                            {item.expiresAt
                                                ? new Date(item.expiresAt).toLocaleDateString()
                                                : "No Expiry"}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
